/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgGarbageOff = (props: Props) => (
  <Icon viewBox="0 0 24 25" {...props}>
    <g fill="none">
      <path
        d="m20 22.214 1.293 1.293 1.414-1.414-20-20-1.414 1.414L4.586 6.8H2v2h2v14h16v-.586zm-2-2v.586H6v-12h.586L9 11.214V18.8h2v-5.586l2 2V18.8h2v-1.586l3 3zm2-3.649V8.8h2v-2h-5v-4H7v.765l2 2V4.8h6v2h-4.765l2 2H18v5.765l2 2zM15 10.8v.765l-.765-.765H15z"
        fill="currentcolor"
      />
    </g>
  </Icon>
);
export { SvgGarbageOff as GarbageOff };
